import { ReactNode, useEffect } from 'react';
import { Navigate, useParams } from 'react-router';
import { useAuthStore } from '../store/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  allowOwnProfile?: boolean; // Allow students to access their own profile
}

export const ProtectedRoute = ({ children, requireAdmin = false, allowOwnProfile = false }: ProtectedRouteProps) => {
  const { isAuthenticated, user, initialize } = useAuthStore();
  const { id } = useParams();

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user?.role !== 'admin') {
    // If allowOwnProfile is true and user is a student accessing their own profile, allow it
    if (allowOwnProfile && user?.role === 'student' && user?.student_id && id && parseInt(id) === user.student_id) {
      return <>{children}</>;
    }

    // Otherwise redirect students to their profile, others to home
    const redirectPath = user?.student_id ? `/students/${user.student_id}` : '/';
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
